import React, { useState } from 'react';

export const AudiosrcContext = React.createContext();

const AudioProvider = ({ children }) => {
  let [audiosrc, setAudiosrc] = useState(null);
  return (
    <AudiosrcContext.Provider value={[audiosrc, setAudiosrc]}>
      {children}
    </AudiosrcContext.Provider>
  )
}

export default AudioProvider;